import React, { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import SmoothScroll from "./components/SmoothScroll";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PackagesPage from "./pages/PackagesPage";
import PackageDetailPage from "./pages/PackageDetailPage";
import ShopPage from "./pages/ShopPage";
import ShopProductPage from "./pages/ShopProductPage";
import CorporatePage from "./pages/CorporatePage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import BlueprintPage from "./pages/BlueprintPage";
import BlueprintSelectPage from "./pages/BlueprintSelectPage";
import CareerBlueprintPage from "./pages/CareerBlueprintPage";
import BlueprintAdminPage from "./pages/BlueprintAdminPage";
import NotFoundPage from "./pages/NotFoundPage";
import { BlogIndex, BlogPost } from "./pages/BlogPage";

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
    }, [pathname, hash]);
    return null;
}

function App() {
    return (
        <div className="App ssh-grain">
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/packages" element={<PackagesPage />} />
                        <Route path="/packages/:slug" element={<PackageDetailPage />} />
                        <Route path="/shop" element={<ShopPage />} />
                        <Route path="/shop/:slug" element={<ShopProductPage />} />
                        <Route path="/corporate" element={<CorporatePage />} />
                        <Route path="/blog" element={<BlogIndex />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/payment/success" element={<PaymentSuccessPage />} />
                        <Route path="/relationship-blueprint" element={<BlueprintPage />} />
                        <Route path="/career-blueprint" element={<CareerBlueprintPage />} />
                        <Route path="/blueprint" element={<BlueprintSelectPage />} />
                        <Route path="/admin/blueprint" element={<BlueprintAdminPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingWhatsApp />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        classNames: {
                            toast: "bg-white border border-[#EFEBE4] text-[#2C2B29] rounded-none",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
